import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Vehicle
 */
export class Vehicle {
    /**
     * getList
     */
    static async getList() {
        const result = await NetFetch.getData('/json/vehicle/list');
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK: {
                    const response = result;
                    return response.list;
                }
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * save
     * @param vehicle
     */
    static async save(vehicle) {
        const result = await NetFetch.postData('/json/vehicle/save', vehicle);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
                default:
                    if (result.msg) {
                        throw Error(result.msg);
                    }
            }
        }
        return false;
    }
    /**
     * delete
     * @param vdelete
     */
    static async delete(vdelete) {
        const result = await NetFetch.postData('/json/vehicle/delete', vdelete);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
                default:
                    if (result.msg) {
                        throw Error(result.msg);
                    }
            }
        }
        return false;
    }
}
